import { isMobileViewport, watchMobileViewport } from './mobileViewport'

// Presentation-only support for existing tables. No column, row or selection data is changed.
export default function installMobileTableSupport(Vue) {
  Vue.mixin({
    mounted() {
      if (this.$options.name !== 'ElTable') return
      const routeName = this.$route && this.$route.name || ''
      if (/performance|qiancMaterial/i.test(routeName)) return
      const table = this.$el
      if (!table.closest('.page-content, .el-dialog, .el-drawer')) return
      let guide = null
      let frame = null
      let body = null
      const removeGuide = () => {
        if (guide && guide.parentNode) guide.parentNode.removeChild(guide)
        guide = null
      }
      const refresh = () => {
        frame = null
        if (!isMobileViewport() || !table.isConnected) { removeGuide(); return }
        const scroller = table.querySelector('.el-table__body-wrapper')
        if (!scroller || scroller.scrollWidth <= scroller.clientWidth + 2) { removeGuide(); return }
        if (!guide) {
          guide = document.createElement('div')
          guide.className = 'jl-mobile-table-guide'
          const label = document.createElement('span')
          label.textContent = '左右滑动查看完整字段'
          const button = document.createElement('button')
          button.type = 'button'
          button.addEventListener('click', () => {
            const atEnd = scroller.scrollLeft >= scroller.scrollWidth - scroller.clientWidth - 2
            scroller.scrollTo({ left: atEnd ? 0 : Math.min(scroller.scrollWidth, scroller.scrollLeft + scroller.clientWidth * 0.8), behavior: 'smooth' })
          })
          guide.appendChild(label)
          guide.appendChild(button)
          table.parentNode.insertBefore(guide, table)
        }
        const atEnd = scroller.scrollLeft >= scroller.scrollWidth - scroller.clientWidth - 2
        guide.lastChild.textContent = atEnd ? '返回首列 ←' : '查看右侧 →'
        if (body !== scroller) {
          if (body) body.removeEventListener('scroll', schedule)
          body = scroller
          body.addEventListener('scroll', schedule, { passive: true })
        }
      }
      const schedule = () => { if (frame === null) frame = window.requestAnimationFrame(refresh) }
      const stop = watchMobileViewport(() => { schedule(); this.$nextTick(() => this.doLayout()) })
      const observer = window.ResizeObserver ? new window.ResizeObserver(schedule) : null
      if (observer) observer.observe(table)
      window.addEventListener('resize', schedule, { passive: true })
      this._jlRefreshTable = schedule
      this._jlCleanupTable = () => {
        stop()
        if (observer) observer.disconnect()
        window.removeEventListener('resize', schedule)
        if (body) body.removeEventListener('scroll', schedule)
        if (frame !== null) window.cancelAnimationFrame(frame)
        removeGuide()
      }
      schedule()
    },
    updated() { if (this._jlRefreshTable) this._jlRefreshTable() },
    beforeDestroy() { if (this._jlCleanupTable) this._jlCleanupTable() }
  })
}



// WEBPACK FOOTER //
// ./src/utils/mobileTableSupport.js